import { Card, Skeleton, Space } from "antd";
import React from "react";
import { FallbackPageContent } from "./FallbackPageContent";

export const PageContentFallback: React.FC = () => (
  <FallbackPageContent>
    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
      <Card size="small">
        <Skeleton active paragraph={{ rows: 2 }} />
      </Card>
      <Card size="small">
        <Skeleton active title={false} paragraph={{ rows: 1 }} />
      </Card>
      <Card>
        <Skeleton active paragraph={{ rows: 4 }} />
      </Card>
    </Space>
  </FallbackPageContent>
);
